
class WorkerRoleDataSource extends MIOObject
{
    private tableView:UITableView = null;
    initWithTableView(tableView:UITableView){
        this.tableView = tableView;
    }

    private _searchString:string = null;
    set searchString(searchString:string){
        this._searchString = searchString;
        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    cellAtIndexPath(tableView:UITableView, indexPath: MIOIndexPath) {
        let cell = tableView.dequeueReusableCellWithIdentifier("RoleCell") as WorkerRoleCell;
        
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath);                       
        //let name = MIOLocalizeString(item.title.toUpperCase(), item.title);

        cell.item = item;
        // this link dictates the use of the check mark
        //cell.accessoryType = this._user.businessPermission.hasManagerPermision(item.bitMask) ? MUITableViewCellAccessoryType.Checkmark : MUITableViewCellAccessoryType.None;
        return cell;
    }

    private _fetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){        
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad:AppDelegate = MUIWebApplication.sharedInstance().delegate;
    
        let sd = [MIOSortDescriptor.sortDescriptorWithKey('name', true)];

        let predicateFormat:string = null;
        if (this._searchString != null) predicateFormat = "name CONTAINS '" + this._searchString + "'";
        
        let fetchRequest:MIOFetchRequest = DBHelper.listFetchRequestWithEntityName("WorkerRole", sd, predicateFormat);
        //fetchRequest.relationshipKeyPathsForPrefetching = ["department"];
 
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
    
    controllerDidChangeContent(controller:MIOFetchedResultsController){        
        this.tableView.reloadData();
    }
}